import { Collaboration } from 'layouts';
import { CollaborationIndexProps } from 'layouts/Collaboration';
import { getFeaturedReel } from 'lib/api/videos';

export async function getStaticProps() {
    const props: CollaborationIndexProps = {
        featuredVideo: getFeaturedReel(),
    };

    return {
        props,
    };
}

export default Collaboration;
